import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=7753fc1c"
import script from "../../services/ticketing/Customers.js?vue&type=script&lang=js&external"
export * from "../../services/ticketing/Customers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports